import { render } from "./order-product-return-modal.vue?vue&type=template&id=6f93e36f"
import script from "./order-product-return-modal.vue?vue&type=script&lang=js"
export * from "./order-product-return-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__